import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { publicIpv4 } from 'public-ip';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContratacaoRotaInteligenteService {

  constructor( private readonly http : HttpClient ) { }

  public getAllPlanos (idEmpresa) {  
    return this.http.get( `/apiconnect/importation/hire/monthly-plan/${idEmpresa}/companies` ); 
  }

  public getPlanoAvulso (idEmpresa) {  
    return this.http.get( `/apiconnect/importation/hire/separate-plan/${idEmpresa}/companies` ); 
  }

  public getContrato (idEmpresa , ipUsuario) {    
    return this.http.get( `/apiconnect/importation/hire/data/${idEmpresa}/companies?contactid=0&userip=${ipUsuario}` );
  }

  public getIpUsuario (){
    return from(publicIpv4().then(ip => {
      return { ip }
    }))
  } 

  public getPlanoContratado (idEmpresa , url ){
    return this.http.get (`/apiconnect/importation/hire/plan/${idEmpresa}/companies${url}`);
  }
  public getDownloadContrato (idEmpresa , url ){
    return this.http.get (`/apiconnect/importation/hire/plan-donwload/${idEmpresa}/companies${url}`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
